

























































import Vue from 'vue'
export default Vue.extend({
  name: 'InputIp',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: () => ""
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      ip1: undefined,
      ip2: undefined,
      ip3: undefined,
      ip4: undefined,
    }
  },
  watch: {
    value: {
      handler(newVal,oldVal){
        this.init();
        // this.handlerNumber('ip1', newVal,oldVal);
      }
    },
    ip1:{
      handler(newVal,oldVal){
        this.handlerNumber('ip1', newVal,oldVal);
      }
    },
    ip2:{
      handler(newVal,oldVal){

        this.handlerNumber('ip2', newVal,oldVal);
      }
    },
    ip3:{
      handler(newVal,oldVal){
        this.handlerNumber('ip3', newVal,oldVal);
      }
    },
    ip4:{
      handler(newVal,oldVal){
        this.handlerNumber('ip4', newVal,oldVal);
      }
    }
  },
  mounted(){
    this.init();
    
  },
  methods: {
    init(){
      if(!this.value){
        return;
      }

      const ipArray = this.value.split(".")
      ipArray.forEach((v,i)=>{
        if(i===0){
          this.ip1=v;
        } else if(i===1){
          this.ip2=v;
        } else if(i===2){
          this.ip3=v;
        } else {
          this.ip4=v;
        }
      })
    },
    focus(type){
      switch(type){
          case 'ip1':
            this.$refs.ip2.focus();
            break;
          case 'ip2':
            this.$refs.ip3.focus();
            break;
          case 'ip3':
            this.$refs.ip4.focus();
            break;
        } 
    },
    onPressEnter(type){
      this.focus(type);  
    },
    handlerNumber(type,newVal,oldVal){
      if(oldVal===undefined){
        return;
      }
        if(newVal && newVal.toString().endsWith('.')){
          this.setIpValue(type,oldVal);
          this.focus(type);
          return;
        }
        if(newVal!==undefined){
          const num = Number(newVal);
          if(isNaN(num)){
            this.setIpValue(type,oldVal);
            return;
          }
          else if(num<0){
            this.setIpValue(type,0);
          }else if(num>255){
            this.setIpValue(type,255);
          }
          if(newVal.length>=3){
            this.focus(type);
          }
        }
    },
    setIpValue(type,value){
      switch(type){
        case 'ip1':
          this.ip1=value;
          break;
        case 'ip2':
          this.ip2=value;
          break;
        case 'ip3':
          this.ip3=value;
          break;
        case 'ip4':
          this.ip4=value;
          break;
      }
    },
    valueChange(type){
      this.$emit('change', this.getIp())
      
    },
    getIp(){
      const ip1 = Number.parseInt(this.ip1);
      const ip2 = Number.parseInt(this.ip2);
      const ip3 = Number.parseInt(this.ip3);
      const ip4 = Number.parseInt(this.ip4);

      return [ip1,ip2,ip3,ip4].join(".");
    }
  }
})
